import { render, staticRenderFns } from "./ChangeMaker.vue?vue&type=template&id=5637dbea&"
import script from "./ChangeMaker.vue?vue&type=script&lang=js&"
export * from "./ChangeMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports